var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FeatureAppLoader } from '@feature-hub/react';
import React from 'react';
function splitConfigFromContent(content) {
    const _a = content.fields, { 'feature-app-config': config } = _a, otherFields = __rest(_a, ['feature-app-config']);
    return {
        config,
        content: Object.assign(Object.assign({}, content), { fields: otherFields }),
    };
}
export const FeatureApp = ({ app, id, }) => {
    const { baseUrl, src, serverSrc } = app.model.metadata;
    const { config, content: rawContent } = splitConfigFromContent(app);
    return (React.createElement(FeatureAppLoader, { featureAppId: id, baseUrl: baseUrl, src: src, serverSrc: serverSrc, config: config
            ? {
                __type: 'aem-headless',
                config,
            }
            : undefined, beforeCreate: ({ featureServices }) => {
            if (featureServices['audi-content-service']) {
                featureServices['audi-content-service'].setContent(rawContent);
            }
        } }));
};
FeatureApp.displayName = 'FeatureApp';
//# sourceMappingURL=feature-app.js.map